import { Card, Typography } from "antd/es";
import React from "react";
const { Text } = Typography;

const AggregateSummary = ({ children, extra, loading, title, headStyle }) => {
	return (
		<Card
			style={{ width: 300, height: 225, marginTop: "16px" }}
			hoverable
			loading={loading}
			headStyle={headStyle}
			title={<Text strong>{title}</Text>}>
			<div>{children}</div>
		</Card>
	);
};
export default AggregateSummary;
